import BaseAction from "../base-action";
import ActionController from "../action-controller";

class BaseMove extends BaseAction {
    animateMovement;
    animateTime;
    position;
    quaternion;
    scale;

    constructor(props = {}) {
        super(props);
        let self = this;
        this.animateMovement = props.animateMovement || true;
        this.animateTime = props.animateTime || 2000;
        this.position = props.position || [0, 0, 0];
        this.quaternion = props.quaternion || [0, 0, 0, 1];
        this.scale = props.scale || [1, 1, 1];

        this.startModelSelection = false;
        this.cancelSelection = false;
        this.hideMenuItems = false;

        wv.communicator.addEventListener(text_startModelSelection, function (itemArr) {
            const actionId = itemArr[0];
            if (!self.shouldExecute(actionId)) return;
            MoveObjectActionController.resetStates();
            self.startSelectionForMove();
        });

        wv.communicator.addEventListener(text_cancelModelSelection, function (itemArr) {
            const actionId = itemArr[0];
            if (!self.shouldExecute(actionId)) return;
            self.cancelModelSelectionCallback();
        });

        wv.communicator.addEventListener(text_performModelSelection, function (itemArr) {
            const actionId = itemArr[0];
            if (!self.shouldExecute(actionId)) return;
            const entityNames = itemArr.slice(1);
            MoveObjectActionController.moveObjectEditingAction = true;
            self.selectEntityForEditingMove(entityNames);
        });

        wv.communicator.addEventListener(text_getObjectMatrixForMoveObject, function (itemArr) {
            const actionId = itemArr[0];
            const unsuccessfulResponse = {
                actionId: self.actionId,
                success: false
            };

            if (!self.shouldExecute(actionId)) {
                return unsuccessfulResponse;
            }

            let errorMessage = '';
            if (!MoveObjectActionController.modelId) {
                errorMessage = "No object found to extract data. Please perform move and rotate operation on objects.";
            } else if (wv.effectController.modelCaught || wv.effectController.bodyCaught) {
                errorMessage = "Please complete current move and rotate operation and try again.";
            }

            if (errorMessage) {
                VRMessageController.addMessage({
                    text: errorMessage,
                    priority: VrMessagePriorityEnum.WARNING
                });

                return unsuccessfulResponse;
            }

            const {position, quaternion, scale} = self.getData();

            const payload = {
                success: true,
                modelId: MoveObjectActionController.modelId,
                modelName: MoveObjectActionController.modelName,
                volumeName: MoveObjectActionController.volumeName,
                volumeId: modelManager.getBranchIdFromVolumeName(MoveObjectActionController.volumeName),
                groupId: MoveObjectActionController.groupId,
                groupName: MoveObjectActionController.groupName,
                branchIdList: MoveObjectActionController.branchIdList ? MoveObjectActionController.branchIdList : [],
                position,
                quaternion,
                scale,
                actionId: actionId,
            };

            self.cancel();

            return payload;
        });
    }

    cancelModelSelectionCallback() {
        this.cancelSelection = true;
        this.cancel();
    }

    startSelectionForMove(applyToType) {
        this.cancelSelection = false;
        this.set2dElementsVisibility(false);
        clearAllFeaturesFromAllHandler();
        CatchVolumeFeatureController.onChangeMoveFeature(true);
        CatchVolumeFeatureController.onSelectApplyToType(applyToType);
    }

    set2dElementsVisibility(value) {
        this.hideMenuItems = !value;
        let _2dElements = getAll2DElements();
        _2dElements.forEach(element => {
            if (element.id === 'menuViewToolbar') {
                return;
            }
            element.style.visibility = value ? 'visible' : 'hidden';
        });

        if (this.hideMenuItems) {
            MoveObjectActionController.enableFeature();
            const visible2DMenus = BaseMove.getVisible2DMenus();
            menuViewToolbarController.showOnlyTheseButtons(visible2DMenus);
        } else {
            MoveObjectActionController.disableFeature();
            wv.show2DToolbarItems = true;
            document.dispatchEvent(new CustomEvent('show2DToolbar.enabled'));
        }

        mController.hideWholeMenu();

        JSTreeManager.hideAllOtherTreeViews();
        JSTreeManager.showModelTreeView('modelTreeViewSideNav', false);
    }

    static getVisible2DMenus() {
        const moveAndRotate = wv.menuViewToolbarData.toolbarContainer
            .find(container => container.id === 'modelToolsToolbar').children
            .find(modelTool => modelTool.id === 'MoveFeatureEnabled').children
            .map(feature => feature.id)
            .filter(menuId => !menuId.startsWith('Move'));

        const visible2DMenus = ['MoveWithPrecisionMenu', ...moveAndRotate];

        if (['MoveModel', 'MoveVolume'].includes(ActionController.getActiveAction()?.actionType)) {
            visible2DMenus.push('ConnectorMenu');
        }

        return visible2DMenus;
    }

    cancel() {
        updateCatchModelPosition(undefined, false);
        resetCatchAndMoveVolume();
        CatchVolumeFeatureController.onChangeMoveFeature(false);
        CatchVolumeFeatureController.onChangeMoveBodyPrecision(false);
        if (ConnectorController.anchor || ConnectorController.mover) {
            ConnectorController.clearAllSelection();
        }
        this.startModelSelection = false;
        if (!wv.isSceneModificationDisabled) {
            this.set2dElementsVisibility(true);
        }
        MoveObjectActionController.resetStates();
    }
}

export default BaseMove;
